import type { Genre } from "@libs/types/models/client";

export const DJ_SETS_CATEGORY_ID = "dj-sets";

// The "DJ Sets" browse tile — a category, not a genre: it renders through the
// same BrowseItem as genres but routes to /explore/setlists (all albums whose
// song carries a setlist, release date desc) instead of a genre page.
// The image object is uploaded manually to the genre-images location:
//   gs://lissenprod.appspot.com/images/01442abb-6f4f-44cd-95e1-f6f6bd492408
// (CDN URL below is the serving form of that path; size variants generate
// automatically on upload.)
export const DJ_SETS_CATEGORY: Genre = {
  id: DJ_SETS_CATEGORY_ID,
  name: "DJ Sets",
  image:
    "https://cdn.lissenprod.lissen.live/images/01442abb-6f4f-44cd-95e1-f6f6bd492408",
  primaryColour: "#E8DDF8",
  secondaryColour: "#7B2FE8",
};
